import { takeLatest, call, select } from 'redux-saga/effects';
import { fetchFreshDeviations } from './actionCreators';
import { isApiError, requestPuppy } from '@wix/da-http-client/pkg/request';
import { getDeviationType, getPrimaryTier, isDeviationAuthor } from '../../../DeviationViews/_helpers';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { getCurrentUser } from '../../../publicSession/selectors';
import { DeviationTypes } from '../../../types/deviation';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        const deviations = require('@wix/da-sample-data').deviationsByType.image;
        return {
            deviations: deviations.slice(0, 10)
        };
    }
}
export function fakeResponseComm(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        const deviations = require('@wix/da-sample-data').deviationsByType.commissions;
        return {
            commissions: deviations.slice(0, 10)
        };
    }
}
function* fetchDeviations(deviations) {
    const commissionIds = [];
    const deviationIds = deviations.slice(0, 24).map((d)=>{
        if (getDeviationType(d) === DeviationTypes.COMMISSION) {
            commissionIds.push(d.deviationId);
            return undefined;
        }
        return d.deviationId;
    }).filter((i)=>i !== undefined);
    let devResult;
    let commResult;
    if (deviationIds.length > 0) {
        devResult = yield call(requestPuppy, {
            method: 'get',
            url: `/deviation/multifetch`,
            params: {
                deviationids: deviationIds
            }
        }, fakeResponse);
        if (isApiError(devResult)) {
            return devResult;
        }
    }
    if (commissionIds.length > 0) {
        commResult = yield call(requestPuppy, {
            method: 'get',
            url: `/commission/multifetch`,
            params: {
                commissionids: commissionIds
            }
        }, fakeResponseComm);
        if (isApiError(commResult)) {
            return commResult;
        }
    }
    var _devResult_deviations_length;
    const hasDeviations = ((_devResult_deviations_length = devResult === null || devResult === void 0 ? void 0 : devResult.deviations.length) !== null && _devResult_deviations_length !== void 0 ? _devResult_deviations_length : 0) > 0;
    var _commResult_commissions_length;
    const hasCommissions = ((_commResult_commissions_length = commResult === null || commResult === void 0 ? void 0 : commResult.commissions.length) !== null && _commResult_commissions_length !== void 0 ? _commResult_commissions_length : 0) > 0;
    // Merge results
    if (hasDeviations && hasCommissions) {
        const merged = [
            ...devResult.deviations,
            ...commResult.commissions
        ];
        return deviations.map((d)=>{
            const fresh = merged.find((i)=>i.deviationId === d.deviationId && i.typeId === d.typeId);
            return fresh !== null && fresh !== void 0 ? fresh : d;
        });
    }
    // Only devs
    if (hasDeviations && !hasCommissions) {
        return devResult.deviations;
    }
    // Only commissions
    if (!hasDeviations && hasCommissions) {
        return commResult.commissions;
    }
}
export function* doFetchFresh(action) {
    const { deviations, setEntityData } = action.payload;
    const currentUser = yield select(getCurrentUser);
    const result = yield call(fetchDeviations, deviations);
    if (result && !isApiError(result)) {
        const freshDeviations = result.map((deviation)=>{
            const isInTier = getPrimaryTier(deviation);
            const isOwner = isDeviationAuthor(deviation, currentUser);
            const { isPremium } = normalizePremiumFolderData(deviation.premiumFolderData);
            const isForbidden = isPremium || isInTier && !isOwner;
            if (!isForbidden) {
                return deviation;
            }
            return undefined;
        }).filter((i)=>i !== undefined);
        if (freshDeviations.length > 0) {
            return setEntityData(freshDeviations);
        }
    } else {
        alert('Failed to fetch');
    }
}
export default function* saga() {
    yield takeLatest(fetchFreshDeviations, doFetchFresh);
}
